"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Root = exports.SizePadding = exports.Sizes = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_props_to_styles_1 = require("@hopin-team/ui-helper-props-to-styles");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var polished_1 = require("polished");

var styled_components_1 = tslib_1.__importStar(require("styled-components"));

var area = ui_blocks_1.INTERACTIVE.area,
    isDisabled = ui_blocks_1.INTERACTIVE.isDisabled;
var emphasis = ui_blocks_1.TYPOGRAPHY.emphasis;
var base = styled_components_1.css(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  text-decoration: none;\n  white-space: nowrap;\n  background: transparent;\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    ", "\n    border: 0.0625rem solid\n      ", ";\n  }\n\n  &:disabled:hover,\n  &[aria-disabled='true']:hover {\n    border: 0.0625rem solid\n      ", ";\n  }\n"], ["\n  ", "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  text-decoration: none;\n  white-space: nowrap;\n  background: transparent;\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    ", "\n    border: 0.0625rem solid\n      ", ";\n  }\n\n  &:disabled:hover,\n  &[aria-disabled='true']:hover {\n    border: 0.0625rem solid\n      ", ";\n  }\n"])), emphasis, isDisabled, function (_a) {
  var theme = _a.theme;
  return ui_helper_deep_branding_1.getFromTheme('COLOR.GREY["300"]', theme);
}, function (_a) {
  var theme = _a.theme;
  return ui_helper_deep_branding_1.getFromTheme('COLOR.GREY["300"]', theme);
}); // Sizes =======================================================================

var Sizes;

(function (Sizes) {
  Sizes[Sizes["tiny"] = 4] = "tiny";
  Sizes[Sizes["small"] = 5] = "small";
  Sizes[Sizes["medium"] = 6] = "medium";
  Sizes[Sizes["large"] = 7] = "large";
})(Sizes = exports.Sizes || (exports.Sizes = {}));

var SizePadding;

(function (SizePadding) {
  SizePadding[SizePadding["tiny"] = 1] = "tiny";
  SizePadding[SizePadding["small"] = 2] = "small";
  SizePadding[SizePadding["medium"] = 3] = "medium";
  SizePadding[SizePadding["large"] = 4] = "large";
})(SizePadding = exports.SizePadding || (exports.SizePadding = {}));

var makeSizeStyles = function makeSizeStyles(size, theme) {
  var _a, _b;

  return styled_components_1.css(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  height: ", ";\n  padding: 0 ", ";\n"], ["\n  height: ", ";\n  padding: 0 ", ";\n"])), ui_symbols_1.calcSpace(Sizes[size], (_a = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _a === void 0 ? void 0 : _a.STEP), ui_symbols_1.calcSpace(SizePadding[size], (_b = theme === null || theme === void 0 ? void 0 : theme.SCALE) === null || _b === void 0 ? void 0 : _b.STEP));
}; // Patterns ====================================================================


var Patterns;

(function (Patterns) {
  Patterns["primary"] = "UTILITY.ACTION";
  Patterns["secondary"] = "UTILITY.ACTION";
  Patterns["success"] = "UTILITY.SUCCESS";
  Patterns["danger"] = "UTILITY.ERROR";
  Patterns["warning"] = "UTILITY.WARN";
})(Patterns || (Patterns = {}));

var makePatternStyles = function makePatternStyles(pattern, theme) {
  if (pattern in Patterns) {
    var hoverShade = polished_1.darken(0.1, ui_helper_deep_branding_1.getFromTheme("COLOR." + Patterns[pattern], theme));
    return styled_components_1.css(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n      border: 0.0625rem solid\n        ", ";\n      background: ", ";\n      color: ", ";\n\n      &:hover {\n        border: 0.0625rem solid ", ";\n        background: ", ";\n        color: ", ";\n      }\n    "], ["\n      border: 0.0625rem solid\n        ", ";\n      background: ", ";\n      color: ", ";\n\n      &:hover {\n        border: 0.0625rem solid ", ";\n        background: ", ";\n        color: ", ";\n      }\n    "])), ui_helper_deep_branding_1.getFromTheme("COLOR." + Patterns[pattern], theme), ui_helper_deep_branding_1.getFromTheme("COLOR." + Patterns[pattern], theme), pattern === 'success' || pattern === 'warning' ? ui_helper_deep_branding_1.getFromTheme('COLOR.GREY["900"]', theme) : ui_helper_deep_branding_1.getFromTheme('COLOR.GREY.WHITE', theme), hoverShade, hoverShade, pattern === 'success' || pattern === 'warning' ? ui_helper_deep_branding_1.getFromTheme('COLOR.GREY["900"]', theme) : ui_helper_deep_branding_1.getFromTheme('COLOR.GREY.WHITE', theme));
  }

  return '';
}; // Outlined ====================================================================


var OutlinePatterns = {
  primary: {
    color: 'UTILITY.ACTION',
    background: 'BLUE["100"]',
    border: 'BLUE["200"]'
  },
  secondary: {
    color: 'GREY.DARK',
    background: 'GREY["100"]',
    border: 'GREY["200"]'
  },
  success: {
    color: 'UTILITY.SUCCESS',
    background: 'GREEN["100"]',
    border: 'GREEN["200"]'
  },
  danger: {
    color: 'UTILITY.ERROR',
    background: 'RED["100"]',
    border: 'RED["200"]'
  },
  warning: {
    color: 'UTILITY.WARN',
    background: 'ORANGE["100"]',
    border: 'ORANGE["200"]'
  }
};

var makeOutlinedStyles = function makeOutlinedStyles(_a) {
  var _b = _a.pattern,
      pattern = _b === void 0 ? 'primary' : _b,
      isOutlined = _a.isOutlined,
      theme = _a.theme;

  if (isOutlined && pattern in OutlinePatterns) {
    return styled_components_1.css(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n      background: transparent;\n      border: 0.0625rem solid\n        ", "};\n      color: ", ";\n\n      &:hover {\n        border: 0.0625rem solid ", ";\n        background: ", ";\n        color: ", ";\n      }\n\n      &:disabled,\n      &[aria-disabled='true'] {\n        border: 0.0625rem solid\n          ", ";\n        background: transparent;\n        color: ", ";\n      }\n\n      &:disabled:hover,\n      &[aria-disabled='true']:hover {\n        border: 0.0625rem solid\n          ", ";\n        background: transparent;\n        color: ", ";\n      }\n    "], ["\n      background: transparent;\n      border: 0.0625rem solid\n        ", "};\n      color: ", ";\n\n      &:hover {\n        border: 0.0625rem solid ", ";\n        background: ", ";\n        color: ", ";\n      }\n\n      &:disabled,\n      &[aria-disabled='true'] {\n        border: 0.0625rem solid\n          ", ";\n        background: transparent;\n        color: ", ";\n      }\n\n      &:disabled:hover,\n      &[aria-disabled='true']:hover {\n        border: 0.0625rem solid\n          ", ";\n        background: transparent;\n        color: ", ";\n      }\n    "])), ui_helper_deep_branding_1.getFromTheme('COLOR.GREY["300"]', theme), ui_helper_deep_branding_1.getFromTheme("COLOR." + OutlinePatterns[pattern].color, theme), ui_helper_deep_branding_1.getFromTheme("COLOR." + OutlinePatterns[pattern].border, theme), ui_helper_deep_branding_1.getFromTheme("COLOR." + OutlinePatterns[pattern].background, theme), ui_helper_deep_branding_1.getFromTheme("COLOR." + OutlinePatterns[pattern].color, theme), function (_a) {
      var theme = _a.theme;
      return ui_helper_deep_branding_1.getFromTheme('COLOR.GREY["300"]', theme);
    }, function (_a) {
      var theme = _a.theme;
      return ui_helper_deep_branding_1.getFromTheme('COLOR.GREY["400"]', theme);
    }, function (_a) {
      var theme = _a.theme;
      return ui_helper_deep_branding_1.getFromTheme('COLOR.GREY["300"]', theme);
    }, function (_a) {
      var theme = _a.theme;
      return ui_helper_deep_branding_1.getFromTheme('COLOR.GREY["400"]', theme);
    });
  }

  return;
}; // Inverse =====================================================================


var isInverseOutlinedStyles = "\n  border: 0.0625rem solid rgba(255, 255, 255, 0.35);\n  background-color: transparent;\n  color: rgba(255, 255, 255, 1);\n\n  &:hover {\n    border: 0.0625rem solid rgba(255, 255, 255, 0.35);\n    background-color: rgba(255, 255, 255, 0.1);\n    color: rgba(255, 255, 255, 1);\n  }\n\n  &:disabled,\n  &[aria-disabled='true'] {\n    background-color: transparent;\n    color: rgba(255, 255, 255, 0.35);\n    border-color: rgba(255, 255, 255, 0.1);\n    &:hover {\n      background-color: transparent;\n      color: rgba(255, 255, 255, 0.35);\n      border-color: rgba(255, 255, 255, 0.1);\n    }\n  }\n";

var makeIsInverseStyles = function makeIsInverseStyles(_a) {
  var pattern = _a.pattern,
      isOutlined = _a.isOutlined;

  if (isOutlined) {
    return isInverseOutlinedStyles;
  }

  if (!!pattern && pattern in Patterns) {
    return "\n      &:disabled,\n      &[aria-disabled='true'] {\n        border: 0.0625rem solid #757a8a;\n        background-color: rgba(255, 255, 255, 0.1);\n        color: rgba(255, 255, 255, 0.5);\n      }\n\n      &:disabled:hover,\n      &[aria-disabled='true']:hover {\n        border: 0.0625rem solid #757a8a;\n        background-color: rgba(255, 255, 255, 0.1);\n        color: rgba(255, 255, 255, 0.5);\n      }\n    ";
  }

  return '';
}; // Inline ======================================================================


var isInlineStyles = styled_components_1.css(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  display: inline-flex;\n  width: unset;\n"], ["\n  display: inline-flex;\n  width: unset;\n"]))); // With icons ==================================================================

var isLeadingStyles = "\n padding-left: 0;\n";
var isTrailingStyles = "\n  padding-right: 0;\n";
exports.Root = styled_components_1.default.button(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), area, base, function (props) {
  return ui_helper_props_to_styles_1.makeStyles(props, 'size', makeSizeStyles);
}, function (props) {
  return ui_helper_props_to_styles_1.makeStyles(props, 'pattern', makePatternStyles);
}, function (props) {
  return makeOutlinedStyles(props);
}, function (props) {
  return props.isInverse && makeIsInverseStyles(props);
}, function (props) {
  return ui_helper_props_to_styles_1.switchStyles(props, 'isInline', isInlineStyles);
}, function (props) {
  return ui_helper_props_to_styles_1.switchStyles(props, 'isLeading', isLeadingStyles);
}, function (props) {
  return ui_helper_props_to_styles_1.switchStyles(props, 'isTrailing', isTrailingStyles);
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;